var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'button',_vm._g({tag:"component",staticClass:"b2b-button__icon",class:{
    'b2b-button__icon--active': _vm.active || _vm.activeButton,
    'b2b-button__icon--active-exact': _vm.exact,
    'b2b-button__icon--small': _vm.small,
    'b2b-button__icon--flat': _vm.flat,
  },attrs:{"to":_vm.to,"type":!_vm.to && _vm.type,"disabled":_vm.$_disabled}},_vm.$_listeners),[(_vm.loading)?_c('b2b-loading'):[_vm._t("default"),_vm._t("info")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }